import fetchStats from '@/api/stats';
import AuthResponse from '@/service/AuthResponse';
import Notifications from '@/service/Notifications';

export default {
  fetch (context, id) {
    const { commit } = context;
    commit('setIsLoading', true);
    return fetchStats(id)
      .then(res => AuthResponse.validate(res, context))
      .then(res => {
        if (!res) {
          return;
        }
        commit('setIsLoading', false);
        commit('setItem', res);
        return res;
      })
      .catch(e => Notifications.error(
          e.toString() || 'Failed to retrieve stats',
          () => commit('reset')
        )
      )
    ;
  },
};
